import { Reservation } from 'src/types/reservation'

const useUnmarkAsPurchasedEligible = (reservation: Reservation) =>
  !reservation.isGroupGiftContribution

export default useUnmarkAsPurchasedEligible
